import { ObjectModel } from 'objectmodel';

const DeviceInfo = new ObjectModel({
  bookmarkSupported: Boolean,
  connection: {
    defaultServiceId: Number,
    imei: String,
    simMCC: [String, undefined, null],
    simMNC: [String, undefined, null],
    currentMCC: [String, undefined, null],
    currentMNC: [String, undefined, null],
    simMCC2: [String, undefined, null],
    simMNC2: [String, undefined, null],
    currentMCC2: [String, undefined, null],
    currentMNC2: [String, undefined, null],
    type: [String, undefined, null],
  },
  settings: {
    'apps.analyticsEventBaseUrl': String,
    'apps.graphqlBaseUrl': String,
    'apps.graphql.key': String,
    'apps.searchBaseUrl': String,
    'apps.serviceCenter.microServiceUrl': String,
    'apps.serviceCenter.remoteUrl': String,
    'apps.serviceCenter.settingsEnabled': Boolean,
    'apps.serviceCenterUrl': String,
    'deviceinfo.build_number': String,
    'deviceinfo.cu': String,
    'deviceinfo.hardware': String,
    'deviceinfo.os': String,
    'deviceinfo.product_model': String,
    'deviceinfo.platform_build_id': String,
    'deviceinfo.platform_version': String,
    'deviceinfo.software': String,
    'identity.kaiaccounts.api.uri': String,
    'ril.data.defaultServiceId': Number,
    'store.nativeUpdate.enable': Boolean,
  },
  touchSettings: {
    'home.appsMenu.isFull': Boolean,
  },
}).defaultTo({
  bookmarkSupported: false,
  settings: {
    'apps.analyticsEventBaseUrl': 'https://analytics.kaiostech.com/v1',
    'apps.graphqlBaseUrl': 'https://api.store.kaiostech.com',
    'apps.graphql.key': 'vTPQIDW1Qc5PjgLDBdGDN8334Yil3fre334oToEn',
    'apps.searchBaseUrl': 'https://search.kaiostech.com',
    'apps.serviceCenter.microServiceUrl':
      'https://api.kaiostech.com/kc_ksfe/v1.0',
    'apps.serviceCenter.remoteUrl': 'https://kaios-plus.kaiostech.com',
    'apps.serviceCenter.settingsEnabled': false,
    'apps.serviceCenterUrl': 'https://api.kaiostech.com/v3.0',
    'deviceinfo.build_number': '',
    'deviceinfo.cu': '4044O-2BAQUS1-R',
    'deviceinfo.hardware': 'unknown',
    'deviceinfo.os': 'unknown',
    'deviceinfo.product_model': 'unknown',
    'deviceinfo.platform_build_id': '',
    'deviceinfo.platform_version': '',
    'deviceinfo.software': 'unknown',
    'identity.kaiaccounts.api.uri': 'https://api.kaiostech.com',
    'ril.data.defaultServiceId': 0,
    'store.nativeUpdate.enable': false,
  },
  touchSettings: {
    'home.appsMenu.isFull': false,
  },
});

export { DeviceInfo };
